import { EntityTable } from 'Dexie';
import { z } from 'zod';

export enum ActionDetailsStatus {
  editedLocal,
  deletedLocal,
  offline,
  pending,
  sending,
  synced,
}

export const ActionTableSchema = z.object({
  processId: z.number().nullable().optional(),
  //localProcessId: z.string(), // unique identifier
  dateIndex: z.string().transform((val) => new Date(val)), // store as ISO string, transform to Date
  description: z.string(),
  detail: z.string(),
  dateBegin: z.string().transform((val) => new Date(val)),
  dateEnd: z.string().transform((val) => new Date(val)),
  statusIndex: z.number().int().min(0).max(Object.keys(ActionDetailsStatus).length / 2 - 1),
  errorCreating: z.boolean().nullable().optional(),
})

export type ActionTable = z.infer<typeof ActionTableSchema>;
export type DexieActionTable = EntityTable<ActionTable, 'processId'>;
export const ActionTableColumn = 'processId, dateIndex, description, detail, dateBegin, dateEnd, statusIndex, errorCreating';
